export interface InputState {
  /** Mouse pos in CSS pixels relative to canvas. */
  mouseX: number;
  mouseY: number;
  splitPressed: boolean;
  keyX: number; // -1, 0, 1
  keyY: number; // -1, 0, 1
  /** Accumulated wheel-delta-Y since last consume; positive = zoom out. */
  wheelDelta: number;
}

export function bindInput(canvas: HTMLCanvasElement): InputState {
  const state: InputState = { mouseX: 0, mouseY: 0, splitPressed: false, keyX: 0, keyY: 0, wheelDelta: 0 };
  const pressed = new Set<string>();

  function updateKeyAxes() {
    const left = pressed.has("a");
    const right = pressed.has("d");
    const up = pressed.has("w");
    const down = pressed.has("s");
    state.keyX = (right ? 1 : 0) - (left ? 1 : 0);
    state.keyY = (down ? 1 : 0) - (up ? 1 : 0);
  }

  const onMove = (e: MouseEvent) => {
    const rect = canvas.getBoundingClientRect();
    state.mouseX = e.clientX - rect.left;
    state.mouseY = e.clientY - rect.top;
  };
  const onKeyDown = (e: KeyboardEvent) => {
    if (e.code === "Space") {
      e.preventDefault();
      state.splitPressed = true;
    }
    const key = e.key.toLowerCase();
    if (["w", "a", "s", "d"].includes(key)) {
      pressed.add(key);
      updateKeyAxes();
    }
  };
  const onKeyUp = (e: KeyboardEvent) => {
    const key = e.key.toLowerCase();
    if (pressed.has(key)) {
      pressed.delete(key);
      updateKeyAxes();
    }
  };
  const onWheel = (e: WheelEvent) => {
    e.preventDefault();
    state.wheelDelta += e.deltaY;
  };
  canvas.addEventListener("mousemove", onMove);
  canvas.addEventListener("wheel", onWheel, { passive: false });
  window.addEventListener("keydown", onKeyDown);
  window.addEventListener("keyup", onKeyUp);

  return state;
}
